import axios from '../utils/axios';
let activeApi={
    // 新增
    addactivecom(params, success){
        axios('/active/addactivecom', params, success)
    },
    // 获取用户列表
    getactivecom(params, success){
        axios('/active/getactivecom', params, success)
    },


}
export default activeApi


// WEBPACK FOOTER //
// ./src/api/active.js